import PropTypes from 'prop-types';
import Text from 'common/components/Text';
import Link from 'next/link';
import Button from 'common/components/Button';
import { Mixpanel } from 'utils/mixpanel';
import { PostCard } from '../blog.style';

const RightInfo = ({ data, button, id }) => {
  return (
    <div id="postcard-container">
      <PostCard id={id}>
        <Text
          mt={4}
          as='h3'
          textAlign='center'
          content={'Ready to try Swiftask.ai?'}
        />
        <Link href='https://app.swiftask.ai' legacyBehavior>
          <a className='navbar_drawer_button'>
            <Button
              onClick={() => {
                Mixpanel.track('Article view - Get Started', {
                  'Article title': data?.title,
                });
              }}
              {...button}
              title='Get Started'
            />
          </a>
        </Link>
      </PostCard>
    </div>
  );
};
RightInfo.propTypes = {
  imageStyle: PropTypes.object,
  boxPublishedDate: PropTypes.object,
  styleAuthor: PropTypes.object,
  datePublished: PropTypes.object,
  styleAuthorType: PropTypes.object,
  button: PropTypes.object,
};
RightInfo.defaultProps = {
  button: {
    type: 'button',
    fontSize: '18px',
    fontWeight: '700',
    borderRadius: '4px',
    pl: '15px',
    pr: '15px',
    color: 'white',
    width: '100%',
    colors: 'primaryWithBg',
    minHeight: 'auto',
    height: '40px',
  },
  datePublished: {
    textTransform: 'capitalize',
  },
  styleAuthorType: {
    textTransform: 'capitalize',
    letterSpacing: '.16em',
  },
  boxPublishedDate: {
    textTransform: 'uppercase',
    letterSpacing: '.08em',
    display: 'flex',
    fontWeight: 500,
    marginBottom: '30px',
    height: '2rem',
    color: '#484848',
  },
  styleAuthor: {
    textTransform: 'capitalize',
    letterSpacing: '.08em',
    fontWeight: 700,
  },
  imageStyle: {
    width: 60,
    height: 60,
    borderRadius: '50%',
  },
};
export default RightInfo;
